
import { defineComponent, ref } from 'vue';
import UpdateBzy from './components/update-bzy.vue';
import UpdateZy from './components/update-zy.vue';
import Card from './components/card/index.vue';
import {
  IAppManageInfoItem,
} from '@/api/manage-app/app-manage/index.d';
import {
  USER_SYSTEM_ENUM,
} from '@/constant';
import { useAppList } from '@/views/app/app-manage/composables/useAppList';

export default defineComponent({
  components: {
    UpdateBzy,
    UpdateZy,
    Card,
  },
  setup() {
    const { appList } = useAppList();
    const currentApp = ref({} as IAppManageInfoItem);
    const updateComponent = ref<string>('');
    const handleChangeAppType = (val: string) => {
      const app = appList.value.find((item: IAppManageInfoItem) => item.appCode === val) || {} as IAppManageInfoItem;
      currentApp.value = {
        ...app,
      };
      updateComponent.value = currentApp.value.dataChannel === USER_SYSTEM_ENUM.SSO ? 'UpdateZy' : 'UpdateBzy';
    };

    return {
      appList,
      handleChangeAppType,
      currentApp,
      updateComponent,
    };
  },
});
